piwik = (function () {
    var public = {

        id: 1,
        url: "//stats.enwoxsystems.cz/",
        isLoggedIn: false,
        username: "",

        send: function() {
            _paq.push(['setCustomVariable', 1, "isLoggedIn", this.isLoggedIn, "visit"]);
            if (this.isLoggedIn) {
                _paq.push(['setCustomVariable', 2, "user", this.username, "visit"]);
            }
            _paq.push(['trackPageView']);
            _paq.push(['enableLinkTracking']);
            (function() {
                var u=piwik.url;
                _paq.push(['setTrackerUrl', u+'piwik.php']);
                _paq.push(['setSiteId', piwik.id]);
                var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                if (!_piwikReady) {
                    g.type = 'text/javascript';
                    g.async = true;
                    g.defer = true;
                    g.src = u + 'piwik.js';
                    s.parentNode.insertBefore(g, s);
                    _piwikReady = true;
                }
            })();
        }
    };

    return public;
})();
